import { Link } from 'react-router-dom'
import textServices from 'services/text-services'
import { SignUpDiv } from 'theme/theme'

function SignUp() {
  return (
    <Link
      to="/signup"
      className="w-full sm:w-72"
      onClick={() => {
        gtag('event', 'Click', {
          event_category: GTM_EVENT_CATEGORY,
          event_label: 'Registro - Email',
          value: 'Email'
        })
      }}
    >
      <SignUpDiv>
        {textServices.findByText('start/signup', 'REGISTRARME')}
      </SignUpDiv>
    </Link>
  )
}

export default SignUp
